// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"88":"f5757abf","142":"9e4de2d5","530":"6b1af22c","686":"dcdcaba7","721":"85afecc5","871":"8f9714b2","895":"c07173f6"}[chunkId] + ".chunk.css";
};